import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class PaymentLoader extends Loader {}

export const paymentLoader = new PaymentLoader({
  service: SERVICES.pay,
})
